<template>
  <v-list-item-content>
    <v-list-item-title> 농약 주요 구매처 </v-list-item-title>
    <v-text-field
      placeholder="시판 / 농협 / 기타 선택"
      ref="refWhereToBuy"
      solo
      :height="formHeight"
      v-model="selectedValue"
      @click="openSelect('주요 구매처 선택', items)"
    >
      <template v-slot:append>
        <v-btn
          x-small
          depressed
          rounded
          @click="openSelect('주요 구매처 선택', items)"
        >
          선택</v-btn
        >
      </template>
    </v-text-field>
    <v-text-field
      placeholder="구입처명을 입력해주세요"
      ref="refWhereToBuyName"
      solo
      :height="formHeight"
      v-model="userData.farm.purchaseName"
      @input="$emit('inputText', $event)"
    />
  </v-list-item-content>
</template>
<script>
export default {
  props: {
    userData: {
      type: Object,
    },
    items: {
      type: [Object, Array],
    },
    formHeight: {
      type: Number,
    },
    orderNum: {
      type: Number,
    },
    selectedValue: {
      type: String,
    },
  },
  methods: {
    openSelect(title, items) {
      console.log("openSelect");
      this.$emit("openSelect", title, items);
    },
  },
};
</script>
<style lang="">
</style>